import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout/index.vue'
import api from '@/utils/api'
import wx from 'weixin-jsapi'
import mapMarkers from '../views/map/index.vue'
import shopDetail from '../views/shopDetail/index.vue'
import mapNavigation from '../views/mapNavigation/index.vue'
import Shop from '../views/shop/index.vue'
Vue.use(VueRouter)

const routes = [
    // 首页
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                redirect: '/home'
            },
            // 首页
            {
                path: '/home',
                name: 'home',
                component: () => import('../views/home/index.vue'),
                meta: { requireTabBar: true, requireAuth: true }
            },
            // 知识库
            {
                path: '/article',
                name: 'article',
                component: () => import('../views/article/index.vue'),
                meta: { requireTabBar: true, requireAuth: true }
            },
            // 抽奖
            {
                path: '/prize',
                name: 'prize',
                component: () => import('../views/prize/index.vue'),
                meta: { requireAuth: true }
            },
            // 我的
            {
                path: '/person',
                name: 'person',
                component: () => import('../views/person/index.vue'),
                meta: { requireAuth: true, requireTabBar: true }
            },
            // 文章详情
            {
                path: '/article-detail',
                name: 'articleDetail',
                component: () => import('../views/article/ArticleDetail.vue'),
                meta: {}
            },
            // 用户基本信息
            {
                path: '/base-info',
                name: 'baseInfo',
                component: () => import('../views/baseInfo/index.vue'),
                meta: { requireAuth: true }
            },
            // 完善资料
            {
                path: '/improve-info',
                name: 'improveInfo',
                component: () => import('../views/improveInfo/index.vue'),
                meta: { requireAuth: true }
            },
            // 搜索
            {
                path: '/search',
                name: 'search',
                component: () => import('../views/search/index.vue'),
                meta: {}
            },
            // 登录
            {
                path: '/login',
                name: 'login',
                component: () => import('../views/login/index.vue'),
                meta: {}
            },
            // 中奖消息
            {
                path: '/gift-list',
                name: 'giftList',
                component: () => import('../views/giftList/index.vue'),
                meta: { requireAuth: true }
            },
            // 中奖消息 - 详情
            {
                path: '/gift-detail',
                name: 'giftDetail',
                component: () => import('../views/giftList/GiftDetail.vue'),
                meta: { requireAuth: true }
            },
            // 联系我们
            {
                path: '/contact',
                name: 'contact',
                component: () => import('../views/contact/index.vue'),
                meta: { requireAuth: true }
            },
            // 我的积分
            {
                path: '/point',
                name: 'point',
                component: () => import('../views/point/index.vue'),
                meta: { requireAuth: true }
            },
            // 我的收藏
            {
                path: '/collected',
                name: 'collected',
                component: () => import('../views/article/index.vue'),
                meta: { requireAuth: true }
            },
            // 意见反馈
            {
                path: '/feedback',
                name: 'feedback',
                component: () => import('../views/feedback/index.vue'),
                meta: { requireAuth: true }
            },
            // 意见列表
            {
                path: '/feedbacklist',
                name: 'feedbacklist',
                component: () => import('../views/feedbacklist/index.vue'),
                meta: { requireAuth: true }
            },
            // 常见问题
            {
                path: '/faq',
                name: 'faq',
                component: () => import('../views/faq/index.vue'),
                meta: { requireAuth: true }
            },
            // 追踪溯源结果
            {
                path: '/trace',
                name: 'trace',
                component: () => import('../views/trace/index.vue'),
                meta: { requireAuth: true }
            },
            // 扫一扫
            {
                path: '/scan-code',
                name: 'scan-code',
                component: () => import('../views/scanCode/index.vue'),
                meta: { requireAuth: true }
            },
            // 明暗码校验
            {
                path: '/verify',
                name: 'verify',
                component: () => import('../views/verify/index.vue'),
                meta: { requireAuth: true }
            },
            // 明暗码校验 - 结果
            {
                path: '/verify-result',
                name: 'verifyResult',
                component: () => import('../views/verifyResult/index.vue'),
                meta: { requireAuth: true }
            },
            // 明暗码校验 - 查看合格证
            {
                path: '/verify-approval',
                name: 'verifyApproval',
                component: () => import('../views/verifyApproval/index.vue'),
                meta: { requireAuth: true }
            },
            // 附近门店
            {
                path: '/shop',
                name: 'shop',
                // component: () => import('../views/shop/index.vue'),
                component: Shop,
                meta: {
                    // requireAuth: true
                }
            },
            // 附近门店 - 详情
            {
                path: '/shop-detail',
                name: 'shop-detail',
                // component: () => import('../views/shopDetail/index.vue'),
                component: shopDetail,
                meta: { requireAuth: true }
            },
            // 附近门店 - 分布
            {
                path: '/map',
                name: 'map',
                // component: () => import('../views/map/index.vue'),
                component: mapMarkers,
                meta: {
                    // requireAuth: true
                }
            },
            // 附近门店 - 查看路线
            {
                path: '/map-navigation',
                name: 'map-navigation',
                // component: () => import('../views/mapNavigation/index.vue'),
                component: mapNavigation,
                meta: {
                    // requireAuth: true
                }
            },
            // 附近农户
            {
                path: '/farmer',
                name: 'farmer',
                component: () => import('../views/farmerMap/index.vue'),
                meta: {
                    // requireAuth: true
                }
            },
            // 附近农户详情
            {
                path: '/farmerdetail',
                name: 'farmerdetail',
                component: () => import('../views/farmerDetail/index.vue'),
                meta: {
                    // requireAuth: true
                }
            },
            // 测试跳转
            {
                path: '/redirect',
                name: 'redirect',
                component: () => import('../views/redirect/index.vue'),
                meta: {
                    // requireAuth: true
                }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    console.log('routerBeforEach', to, from, next)
    // const params = {
    //     url: window.location.href
    // }
    // api.getWxSdkInfo(params).then((res) => {
    //     if (res.data) {
    //         wx.config({
    //             // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //             appId: res.data.app_id, // 必填，公众号的唯一标识
    //             timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //             nonceStr: res.data.noncestr, // 必填，生成签名的随机串
    //             signature: res.data.signature, // 必填，签名
    //             jsApiList: ['scanQRCode', 'getLocation'] // 必填，需要使用的JS接口列表
    //         })
    //     }
    //     wx.ready(function(e) {
    //         console.log('readyreadyreadyreadyreadyready', e)
    //     })
    // })
    next()
})

export default router
